import { SET_ACTIVE_TAB } from "../actions/types";

const initialState = "";

export const activeTabReducer = (state = initialState, action) => {
  if (action.type === SET_ACTIVE_TAB) {
    return {
      ...state,
      currentActiveTab: action.payload,
    };
  }
  return state;
};

export default activeTabReducer;
